import React from 'react';
import styled from 'styled-components';
import Container from './ui/Container';
import { Eyebrow } from './ui/SectionHeading';

const Root = styled.section`
  padding: clamp(3.5rem, 8vw, 6rem) 0 clamp(2.5rem, 6vw, 4rem);
  background:
    linear-gradient(180deg, rgba(7, 12, 22, 0) 50%, var(--bg-0) 100%),
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px) 0 0 / 64px 64px,
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px) 0 0 / 64px 64px,
    var(--bg-0);
`;

const Title = styled.h1`
  font-size: var(--fs-display);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  max-width: 18ch;
`;

const Lead = styled.p`
  margin-top: 1.25rem;
  max-width: 62ch;
  font-size: clamp(1.0625rem, 1.4vw, 1.1875rem);
  color: var(--text-2);
`;

const Extra = styled.div`
  margin-top: 2rem;
`;

interface PageHeroProps {
  eyebrow: string;
  title: React.ReactNode;
  lead: React.ReactNode;
  children?: React.ReactNode;
  id?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ eyebrow, title, lead, children, id }) => (
  <Root id={id} aria-labelledby="page-title">
    <Container>
      <Eyebrow>{eyebrow}</Eyebrow>
      <Title id="page-title">{title}</Title>
      <Lead>{lead}</Lead>
      {children && <Extra>{children}</Extra>}
    </Container>
  </Root>
);

export default PageHero;
